import React, {useEffect} from "react";
import SetTimeRunMedia from "./SetTimeRunMedia";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {lessonTypeState, testTypeState} from "../../../../../states/test_progress_states";
import {lessonTypes, testTypes} from './../../../../../config/constants';
import Plyr from 'plyr';
import {isTouchAudioState, isTouchVideoState} from "../../../../../states/states";

const GroupMedia = (props) => {
    const {question} = props;
    const testTypeId = useRecoilValue(testTypeState);
    const lessonTypeId = useRecoilValue(lessonTypeState);
    const setIsTouchVideo = useSetRecoilState(isTouchVideoState);
    const setIsTouchAudio = useSetRecoilState(isTouchAudioState);
    const videoClass = 'video' + question?.questionCode;
    const audioClass = 'audio' + question?.questionCode;
    const video = document.getElementsByTagName('video')[0];
    const playVideo = document.getElementsByClassName('plyr__control--overlaid')[0];
    Plyr.setup('.audio_plyr'); // Plyr.setup là bắt buộc để custom Plyr
    Plyr.setup('.video_plyr');

    useEffect(() => {
        if (question.hasAudio)
            SetTimeRunMedia(question.questionCode, 'audio', 'timeAudioRan');
        if (question.hasVideo)
            SetTimeRunMedia(question.questionCode, 'video', 'timeVideoRan');
    }, [question]);

    useEffect(() => {
        if (playVideo && video && video.paused) {
            playVideo.click();
        }
    }, [playVideo]);

    const specialTest = [testTypes.KIEM_TRA, testTypes.THI_CU];
    const specialLesson = [lessonTypes.KT_GIUA_KY, lessonTypes.KT_CUOI_KY];

    const touchVideoHandler = () => {
        setIsTouchVideo(true);
    };

    const touchAudioHandler = () => {
        setIsTouchAudio(true);
    };

    if ((specialTest.includes(testTypeId) || specialLesson.includes(lessonTypeId)) && question.hasAudio) {
        return (
            <div className={"audioPlayer audioPlayerTest"}
                 onTouchStart={() => touchAudioHandler()}>>
                <audio className={"audio_plyr " + audioClass}
                       preload="none"
                       controls
                       autoPlay={false}
                       onEnded={() => {
                           try {
                               document.getElementsByClassName('audioPlayerTest')[0].classList.add('stopEventPointer');
                           }catch (e) {
                               //Log error
                           }

                       }}
                >
                    <source src={question.hasAudio} type="audio/mp3"/>
                </audio>
            </div>
        )
    } else if (question.hasAudio) {
        return (
            <div className={"audioPlayer"}
                 onTouchStart={() => touchAudioHandler()}>
                <audio className={"audio_plyr " + audioClass}
                       preload="none"
                       controls
                       autoPlay={false}
                >
                    <source src={question.hasAudio} type="audio/mp3"/>
                </audio>
            </div>
        )
    }

    if ((specialTest.includes(testTypeId) || specialLesson.includes(lessonTypeId)) && question.hasVideo) { //Không co tua
        return (
            <div className="videoPlayer videoPlayerTest"
                 onTouchStart={() => touchVideoHandler()}
            >
                <video
                    className={'video_plyr ' + videoClass}
                    controls
                    autoPlay={false}
                    muted={"muted"}
                    playsInline
                    preload="none"
                    poster={require('../../../../../assets/images/mocha.png')}
                    onEnded={() => {
                        try {
                            document.getElementsByClassName('videoPlayerTest')[0].classList.add('stopEventPointer');
                        }catch (e) {
                            //Log error
                        }
                    }}
                >
                    <source src={question.hasVideo.trim()} type="video/mp4" media="all and (max-width: 444px)"/>
                </video>
            </div>
        );
    } else if (question.hasVideo) { //dược phép tua
        return (
            <div className="videoPlayer"
                 onTouchStart={() => touchVideoHandler()}
            >
                <video
                    className={'video_plyr ' + videoClass}
                    controls
                    autoPlay={false}
                    muted={"muted"}
                    playsInline
                    preload="none"
                    poster={require('../../../../../assets/images/mocha.png')}
                >
                    <source src={question.hasVideo.trim()} type="video/mp4" media="all and (max-width: 444px)"/>
                </video>
            </div>
        )
    }
    return <></>;
};

export default GroupMedia;
